// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-B":"B_vanlife-roadtrips-B__tpT5D"};